import { usePopoverStyles } from '@chakra-ui/react-v2';
import { chakra, type HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';
import { forwardRef, useContext } from 'react';

import { OverlayContainerRefContext } from '../OverlayContainerRefContext';

export const PopoverOverlay = forwardRef<'div', HTMLChakraProps<'div'>>(
  ({ __css: cssProp, className: classNameProp, ...restProps }, ref) => {
    const styles = usePopoverStyles();
    const { parents } = useContext(OverlayContainerRefContext);
    const parentRef = parents?.at(-1);
    const parentRect = parentRef?.current?.getBoundingClientRect();
    const overlayStyle = {
      pos: 'fixed',
      left: `-${parentRect?.left ?? 0}px`,
      top: `-${parentRect?.top ?? 0}px`,
      w: '100vw',
      h: '100vh',
      ...styles.overlay,
      ...cssProp,
    };
    const className = cx('chakra-popover__overlay', classNameProp);
    return (
      <chakra.div
        ref={ref}
        className={className}
        __css={overlayStyle}
        {...restProps}
      />
    );
  },
);
PopoverOverlay.displayName = 'PopoverOverlay';
